import React, { useContext } from 'react';
import ConfigContext from '../../../contexts/ConfigContext';
import Faq from './Faq';

function PricingFaq() {
  const { vehicle_type, city_name } = useContext(ConfigContext);
  const vehicleType = vehicle_type.toLowerCase();

  const questions = [
    {
      question: `How much does food ${vehicleType} catering cost in ${city_name}?`,
      answer: `Pricing depends on guest count, menu, service style, event length, and location. Send your event details to compare actual quotes from available ${vehicleType}s.`
    },
    {
      question: 'Are there fees?',
      answer: `Requesting quotes is free. Before you book, you'll see the full price, including platform fees.`
    },
    {
      question: `What is the average cost per person for food ${vehicleType} catering?`,
      answer: `There isn't one reliable average. Most quotes are per person for the food, and the number moves with the menu, service style, and guest count. Send your event details and compare actual quotes to get a per-person figure for your event.`
    },
    {
      question: `Are there minimum order requirements for food ${vehicleType} catering?`,
      answer: `Most ${vehicleType}s set a minimum, either a dollar amount or a guest count. It varies by ${vehicleType}, menu, and travel distance, so check each quote for the minimum before you compare totals.`
    },
    {
      question: `What is included in the food ${vehicleType} catering price?`,
      answer: `Usually the food, the crew, service during your event, setup, and cleanup. Plates and napkins are often included; drinks, dessert, or extra service hours may be add-ons. Check each quote for what's included, and ask the ${vehicleType} if something isn't clear.`
    },
    {
      question: `How do I get the best price on food ${vehicleType} catering?`,
      answer: `Compare several quotes, and be flexible where you can. A weekday date, a simpler menu, and a larger guest count usually bring the per-person price down. Sending your request earlier gives you more ${vehicleType}s to compare.`
    },
    {
      question: `Do food ${vehicleType} catering prices vary by cuisine type?`,
      answer: `Yes. Ingredient cost and prep time differ by cuisine, so a taco menu and a seafood menu won't quote the same. Compare quotes across cuisines to see the difference for your event.`
    }
  ];

  return <Faq questions={questions} />;
}

export default PricingFaq;
